import React from "react";

export default function PageHeader({ eyebrow, title, description, action }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 stagger-in">
      <div className="max-w-2xl">
        {eyebrow && <div className="eyebrow eyebrow-dark mb-3" data-testid="page-eyebrow">{eyebrow}</div>}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-navy leading-[0.95] tracking-wide">
          {title}
        </h1>
        {description && (
          <p className="mt-3 text-slate-600 text-base leading-relaxed font-light">{description}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
